import { Alert, AlertIcon, AlertProps } from "@chakra-ui/react";

function AlertMessage({
  message,
  messageFromProps,
  showAlertIcon = true,
  ...props
}: AlertProps & {
  message: string;
  messageFromProps?: string;
  showAlertIcon?: boolean;
}) {
  return (
    <Alert color="black"{...props}  >
      {showAlertIcon && (
        <AlertIcon />
      )}
      {messageFromProps ? messageFromProps : message}
    </Alert>
  );
}

AlertMessage.defaultProps = {
  status: "error",
  variant: "left-accent",
};

export default AlertMessage;
